<template lang="pug">
v-main
  v-container(fluid)
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title Create Chart of Accounts (COA)
      v-divider
      v-card-text
        v-form(ref="form", v-model="valid")
          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Business Unit
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-select(
                v-model="formData.bu",
                :items="filteredBUList",
                item-title="business_unit.bu_name",
                item-value="business_unit",
                return-object,
                label="Select Business Unit",
                :rules="[rules.required]",
                required
              )
                template(v-slot:item="data")
                  v-list-item-title {{ getBUName(data.item) }}
                template(v-slot:selection="data")
                  span {{ getBUName(data.item) }}

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") COA Code
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.code",
                label="COA Code",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Description
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.description",
                label="Description",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Account Type
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.type",
                label="Account Type",
                :rules="[rules.required]",
                required
              )

        v-card-actions.my-8
          v-btn.custom__padding-btn(@click="cancel") Cancel
          v-btn.custom__padding-btn(style="background-color:#006bff; color: white", @click="submit", :disabled="!valid || loading", :loading="loading") Save
</template>

<script>
import axios from "axios";

export default {
  name: "COACreate",
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        bu: null,
        code: "",
        description: "",
        type: "",
      },
      buList: [],
      rules: {
        required: (v) => !!v || "This field is required",
      },
    };
  },
  computed: {
    filteredBUList() {
      const seen = {};
      return this.buList
        .filter(item => {
          return item.business_unit &&
                 item.business_unit.is_active === true &&
                 item.is_payment_voucher === true;
        })
        .filter(item => {
          const bu = item.business_unit || {};
          const buId = bu.id || bu._id;
          if (!buId) return false;
          if (seen[buId]) return false;
          seen[buId] = true;
          return true;
        });
    },
  },
  mounted() {
    this.loadBUList();
  },
  methods: {
    loadBUList() {
      const token = localStorage.getItem("token");
      const userData = this.$store.state.dataUsers;
      const userId = userData.user || userData;
      
      if (userId) {
        axios
          .get(`${process.env.VUE_APP_API}/users/active/bu/${userId._id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.buList = res.data.data || [];
          })
          .catch((err) => {
            this.$toasted.error("Failed to load business units", { icon: "error" });
          });
      }
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      
      this.loading = true;
      const token = localStorage.getItem("token");
      
      const payload = {
        bu_id: this.formData.bu.business_unit.id,
        bu_name: this.formData.bu.business_unit.bu_name,
        code: this.formData.code,
        description: this.formData.description,
        account_type: this.formData.type,
      };
      
      axios
        .post(`${process.env.VUE_APP_API}/coa`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          this.$toasted.success("Success! COA has been created.", { icon: "check_circle" });
          this.$router.push({ name: "COA List" });
        })
        .catch((err) => {
          const errorMsg = err.response && err.response.data && err.response.data.message || "Failed to create COA";
          this.$toasted.error(errorMsg, { icon: "error" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.$router.push({ name: "COA List" });
    },
    getBUName(item) {
      return item.business_unit && item.business_unit.bu_name ? item.business_unit.bu_name : '';
    },
  },
};
</script>

<style scoped>
.custom__padding-btn {
  margin-right: 0.5rem;
}
</style>
